<template>
  <div>
    <img :src="logo" alt="img" class="responsive">
  </div>
</template>

<script>
export default {
  data () {
    return {
      logo: require("@/assets/images/logo/logo-wel-fit.png"),
    }
  },
}
</script>
